/// <reference path="../../lib/app.d.ts" />

export class LoadingLayer
{
	private samplerEnabled = false;
	private streamEnabled = false;

	private $sampler : JQuery;
	private $stream : JQuery;

	constructor(private $root)
	{
		this.$sampler = $root.find(".sxcc-sampler");
		this.$stream = $root.find(".sxcc-stream-wrapper");

		this.$stream.find(".sxcc-close-chat").before(this.getLoadNode());
		this.$sampler.append(this.getLoadNode());
	}

	private update()
	{
		this.$sampler.find(".sxc-loading-layer").remove();
		this.$stream.find(".sxc-loading-layer").remove();

		if ((this.samplerEnabled && this.streamEnabled) || this.streamEnabled) {
			this.$stream.find(".sxcc-close-chat").before(this.getLoadNode());
		} else if (this.samplerEnabled) {
			this.$sampler.append(this.getLoadNode());
		}
	}

	public sampler(visible : boolean = true)
	{
		this.samplerEnabled = visible;
		this.update();
	}

	public stream(visible : boolean = true)
	{
		this.streamEnabled = visible;
		this.update();
	}

	private getLoadNode()
	{
		return $("<div class=\"sxc-loading-layer\"><i></i></div>");
	}

	clear():void {
		this.stream(false);
		this.sampler(false);
	}
}
